import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import withIdContext from '../../decorators/withIdContext';

const MAX_COLUMNS = 12; // maximum number of columns supported by css

export class GridLayout extends Component {
  static propTypes = {
    /** number of columns in which content is organized */
    cols: PropTypes.number,
    /** any React components to render in grid layout */
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]),
    /** determines whether children should be rendered by rows or by columns */
    renderBy: PropTypes.oneOf(['rows', 'columns']),
  };

  static defaultProps = {
    cols: 1,
    children: null,
    renderBy: 'rows',
  };

  getChildrenArray() {
    const { children } = this.props;
    return React.Children.toArray(children);
  }

  getRows() {
    const { cols, renderBy } = this.props;
    const childrenArr = this.getChildrenArray();
    const numOfRows = Math.ceil(childrenArr.length / cols);

    const renderByRows = renderBy === 'rows';
    const rows = new Array(numOfRows).fill().map(() => []);

    return childrenArr.reduce((result, column, i) => {
      const rowIndex = renderByRows ? Math.floor(i / cols) : (i % numOfRows);
      result[rowIndex].push(column);
      return result;
    }, rows);
  }

  renderColumns(columns) {
    const { cols } = this.props;
    const colSize = MAX_COLUMNS / cols;

    return columns.map((column, index) => (
      <Col key={index} md={colSize} className="mb-4 mb-lg-0">
        { column }
      </Col>
    ));
  }

  renderRows(rows) {
    return rows.map((columns, index) => (
      <Row key={index}>
        { this.renderColumns(columns) }
      </Row>
    ));
  }

  render() {
    const rows = this.getRows();

    return (
      <Fragment>
        { this.renderRows(rows) }
      </Fragment>
    );
  }
}

export default withIdContext()(GridLayout);
